import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import MoneyTextBox from 'components/common/money_text_box'
import styles from './edit_amount.less'
import EditForm from '../edit_form'

const i18n = getI18n('components/edit_glimpse/edit_amount')

class EditAmount extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    currencyCode: PropTypes.string.isRequired,
  }

  render() {
    const {
      fields: { goal },
    } = this.props

    return (
      <EditForm {...this.props}>
        <div styleName="title" role="heading" aria-level="1">
          {i18n('title')}
        </div>
        <MoneyTextBox
          {...goal}
          data-pa-focus="goal"
          currencyCode={this.props.currencyCode}
          title={i18n('goal_amount')}
          disableCents={false}
          autoFocus={true}
        />
        <button
          data-nemo="save"
          data-pa-click="save"
          className="vx_btn vx_btn-block"
          styleName="save-button"
        >
          {i18n('save')}
        </button>
      </EditForm>
    )
  }
}

export default cssModules(EditAmount, styles)
